import type { AccessEvaluator } from "../types";

export const CALENDAR_EVENTS_ACCESS_EVALUATOR: AccessEvaluator<"calendar_events"> = {
  getRelatedEnduserIds: (event) =>
    event.attendees.reduce<Set<string>>((acc, curr) => {
      if (curr.type === "enduser") {
        acc.add(curr.id);
      }
      return acc;
    }, new Set<string>()),
  evaluate: ({ record, currentUserId, accessType, accessibleRelatedEnduserIds }) => {
    switch (accessType) {
      case "All":
        return true;
      case "Default":
        return record.creator === currentUserId;
      case "Assigned":
        // Accurate to the backend: grant when at least one enduser attendee is
        // accessible to the user (resolved via the access-restricted endusers
        // read), matching `attendees.id ∈ {accessible endusers}`.
        return accessibleRelatedEnduserIds.size > 0;
      default:
        return false;
    }
  },
};
